export default __webpack_public_path__ + "static/media/img.bb0349e0.png";